import React, { useState } from 'react';
import ProductSelectBottomSheet from '../selection/ProductSelectBottomSheet';
import ProductQuantitiesBottomSheet from '../selection/ProductQuantitiesBottomSheet';
import { ProductSelectionWithQuantity } from '../selection/ProductSelectBottomSheet';
import { Product } from '@domain/product/models/Product';

export type ProductUsedInSelection = ProductSelectionWithQuantity;

interface AddProductToUsedInBottomSheetProps {
  currentProductId: string;
  existingUsedInProductIds: Set<string>;
  onAdd: (selections: ProductUsedInSelection[]) => Promise<void>;
  onClose?: () => void;
}

const AddProductToUsedInBottomSheet: React.FC<AddProductToUsedInBottomSheetProps> = ({
  currentProductId,
  existingUsedInProductIds,
  onAdd,
  onClose,
}) => {
  const [step, setStep] = useState<'select' | 'quantities'>('select');
  const [pickedProducts, setPickedProducts] = useState<Product[]>([]);

  const excludeIds = new Set(existingUsedInProductIds);
  excludeIds.add(currentProductId);

  const selectKey = `usedin-select-${pickedProducts.map(p => p.id).sort().join(',')}`;

  if (step === 'select') {
    return (
      <ProductSelectBottomSheet
        key={selectKey}
        title="Add to Product"
        initialProducts={pickedProducts}
        excludeProductIds={excludeIds}
        getDisabledCaption={id =>
          id === currentProductId ? 'Current product' : 'Already added'
        }
        confirmButtonText={count =>
          count === 0 ? 'Continue' : `Continue with ${count} product${count !== 1 ? 's' : ''}`
        }
        onFinish={selections => {
          setPickedProducts(selections.map(s => s.product));
          setStep('quantities');
        }}
        onClose={() => onClose?.()}
      />
    );
  }

  return (
    <ProductQuantitiesBottomSheet
      key="usedin-quantities"
      products={pickedProducts}
      title="Set quantities"
      hint="How many of this product does each parent product use?"
      confirmButtonText={count => `Add to ${count} product${count !== 1 ? 's' : ''}`}
      onFinish={onAdd}
      onBack={() => setStep('select')}
      onClose={() => onClose?.()}
    />
  );
};

export default AddProductToUsedInBottomSheet;
